export const buildTaskContextObject = (taskOptions) => ({
  categoryclassification: taskOptions.categoryclassification,
  clearminimumprice: taskOptions.clearminimumprice,
  clinic: taskOptions.clinic,
  cutoff: taskOptions.cutoff,
  cutoffmonths: taskOptions.cutoffmonths,
  cutoffthreshold: taskOptions.cutoffthreshold,
  diagnosisignorecount: taskOptions.diagnosisignorecount,
  dontclearqoh: taskOptions.dontclearqoh,
  fullcore: taskOptions.fullcore,
  ...(taskOptions.groupname ? { groupname: taskOptions.groupname } : {}),
  ignorepimslabinfo: taskOptions.ignorepimslabinfo,
  inhousefilter: taskOptions.inhousefilter,
  inhousesrc: taskOptions.inhousesrc,
  labidmode: taskOptions.labidmode,
  locale: taskOptions.locale,
  mergedispensingfees: taskOptions.mergedispensingfees,
  mindiagmatch: taskOptions.mindiagmatch,
  name: taskOptions.name,
  neversold: taskOptions.neversold,
  officialname: taskOptions.officialname,
  omitsizeproperty: taskOptions.omitsizeproperty,
  outputmode: taskOptions.outputmode,
  pass: taskOptions.pass,
  preserveprices: taskOptions.preserveprices,
  preservevariationnames: taskOptions.preservevariationnames,
  ...(taskOptions.rematch?.length ? { rematch: taskOptions.rematch } : {}),
  rxid: taskOptions.rxid,
  salesdrop: taskOptions.salesdrop,
  salesthreshold: taskOptions.salesthreshold,
  updatedsrcfile: taskOptions.updatedsrcfile,
  useprovidedvariationname: taskOptions.useprovidedvariationname,
  vendorfilter: taskOptions.vendorfilter
});

export const createTaskFormData = (taskData) => {
  const formData = new FormData();

  // Append basic task data
  formData.append('name', taskData.name);
  formData.append('business', JSON.stringify(taskData.business));
  formData.append('reSessionId', taskData.importSession.id);
  if (taskData.importRequest) {
    formData.append('completedRequestId', taskData.importRequest.id);
  }
  if (taskData.shouldStartPreprocessor) {
    formData.append(
      'shouldStartPreprocessor',
      taskData.shouldStartPreprocessor
    );
  }
  formData.append('environment', taskData.selectedEnv);

  // Append upload related task data
  if (taskData.useSessionInventoryFile && taskData.sessionInventoryFilePath) {
    formData.append(
      'inventoryItemsFilePath',
      taskData.sessionInventoryFilePath
    );
  }

  formData.append(
    'inputFilesParams',
    JSON.stringify([
      taskData.useSessionInventoryFile
        ? { name: 'inventory_items.csv', type: 'common' }
        : {
            id: taskData.selectedInputFile.id,
            name: taskData.selectedInputFile.name,
            type: taskData.selectedInputFileFormat
          }
    ])
  );

  const filesArray = [];
  if (!taskData.useSessionInventoryFile && taskData.selectedInputFile) {
    if (taskData.selectedInputFile instanceof File) {
      formData.append(`uploads_0`, taskData.selectedInputFile);
    } else {
      filesArray.push({
        id: taskData.selectedInputFile.id,
        type: taskData.selectedInputFile.file_type
      });
    }
  }

  if (taskData.selectedHistoryFile) {
    if (taskData.selectedHistoryFile instanceof File) {
      formData.append(`sales_histories_0`, taskData.selectedHistoryFile);
    } else {
      filesArray.push({
        id: taskData.selectedHistoryFile.id,
        type: taskData.selectedHistoryFile.file_type
      });
    }
  }

  if (!taskData.useRecentResult && taskData.selectedPreviousRunFile) {
    if (taskData.selectedPreviousRunFile instanceof File) {
      formData.append(`previous_runs_0`, taskData.selectedPreviousRunFile);
    } else {
      filesArray.push({
        type: taskData.selectedPreviousRunFile.file_type,
        id: taskData.selectedPreviousRunFile.id
      });
    }
  }

  if (taskData.selectedInventoryFile) {
    if (taskData.selectedInventoryFile instanceof File) {
      formData.append(`inventory_files_0`, taskData.selectedInventoryFile);
    } else {
      filesArray.push({
        type: taskData.selectedInventoryFile.file_type,
        id: taskData.selectedInventoryFile.id
      });
    }
  }

  formData.append('files', JSON.stringify(filesArray));

  // Append task data the matcher processor cares about
  const { taskOptions } = taskData;
  formData.append(
    'params',
    JSON.stringify({
      unitSystem: taskOptions.unitSystem,
      debug: taskOptions.debug,
      context: JSON.stringify(buildTaskContextObject(taskOptions)),
      type: taskOptions.type,
      labMatchingTechnique: taskOptions.labMatchingTechnique,
      defaultlab: taskOptions.defaultlab,
      defaultReferenceLab: taskOptions.defaultReferenceLab,
      historicLab: taskOptions.historicLab,
      filters: taskOptions.filters,
      ...(taskData.recentResultId && taskData.useRecentResult
        ? { recentResultId: parseInt(taskData.recentResultId, 10) }
        : {})
    })
  );

  return formData;
};
